import {Component, OnInit} from '@angular/core';
import {Validators, FormControl, FormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {LocalStorageService} from 'src/app/core/services/local-storage.service';
import {NotificationService} from 'src/app/core/services/notification.service';
import {UserService} from 'src/app/core/services/user.service';
import {Roles} from 'src/app/shared/enums/role-types.enum';
import {AuthService} from '../services/auth.service';
import {emailValidator} from 'src/app/core/helpers/helpers.function';
import {environment} from 'src/environments/environment';

@Component({
  selector: 'eci-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public formGroup: FormGroup;
  public formGroup2: FormGroup;
  public actionType: 'mfa'| 'login'| 'forgotPassword' = 'login';
  public isFirstTime: boolean = true;
  public showAdditionalsFields = false;
  returnUrl: string;

  showPassword: boolean = false;
  public isUserLock: boolean = false;
    private LOCK_TIME: number = 300 * 1000; // Time in ms === 5 min
    mfaType: string;

  constructor(
    private router: Router,
    public authService: AuthService,
    private notify: NotificationService,
    private localStorageSvc: LocalStorageService,
    private userSvc: UserService,
    private route: ActivatedRoute
  ) {
    this.formGroup = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.minLength(6),
        Validators.maxLength(256),
        emailValidator()
      ]),
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(32),
      ])
    });

    this.formGroup2 = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.minLength(6),
        Validators.maxLength(256),
        emailValidator()
      ]),
      code: new FormControl('', [
        Validators.minLength(4),
        Validators.maxLength(256)
      ]),
      password: new FormControl('', [
        Validators.minLength(8),
        Validators.maxLength(256),
        Validators.pattern(/^(?=.*\d)(?=.*[a-z])[0-9a-zA-Z_@./#$^*%&+-]{8,}$/)
      ]),
      repeatPassword: new FormControl('', [
        Validators.minLength(8),
        Validators.maxLength(256),
        Validators.pattern(/^(?=.*\d)(?=.*[a-z])[0-9a-zA-Z_@./#$^*%&+-]{8,}$/)
      ]),
    });

  }

  public ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '';
    console.log(this.returnUrl);

    // Handle action (mfa from register)
    const actionTypeFromQuery = this.route.snapshot.queryParams['actionType'];
    const emailFromQuery = this.route.snapshot.queryParams['email'];
    const passwordFromQuery = this.route.snapshot.queryParams['password'];

    if (actionTypeFromQuery == 'registration') {
      this.actionType = 'mfa';
      this.mfaType = 'registration';
      this.formGroup2.get('email')?.setValue(emailFromQuery || '');
      this.formGroup2.get('password')?.setValue(passwordFromQuery || '');
    }

    const token = this.localStorageSvc.get('token');
    const accessDenied = localStorage.getItem('accessDenied');

    // Expired/invalid session: clear and stay on login
    if (accessDenied || !token || !this.userSvc.userStorage?.company?.id) {
      this.localStorageSvc.clear();
      this.userSvc.user$.next(null);
      if (accessDenied) {
        localStorage.removeItem('accessDenied');
      }
      return;
    }

    // Active session only: user + token present
    if (this.userSvc.userStorage?.company?.isCompleted) {
      switch (this.userSvc.user.role) {
        case Roles.Admin:
          this.router.navigateByUrl('/customers-management');
          break;
        case Roles.IndVatAccount:
          this.router.navigateByUrl('/dashboard');
          break;
        default:
          this.router.navigateByUrl(`/customers-management/details/${this.userSvc.userStorage.company?.id}`);
          break;
      }
    }
    this.localStorageSvc.remove('partnerCoupon');
  }

    // public onSubmit(code?: string): void {
    //     const {email, password} = this.formGroup.value;
    //     this.authService.login({username: email.toLowerCase(), password, code})
    //         .subscribe((res) => {
    //             if (res.message === 'MESSAGES.USER.LOGIN_SUCCESS') {
    //                 this.localStorageSvc.set('packageName', res?.packages?.packageName);
    //                 this.login(res);
    //             } else {
    //                 this.loginResponseHandler(res.message);
    //             }
    //         });
    // }
    public onSubmit(code?: string): void {
      const email = this.mfaType === 'registration'
          ? this.formGroup2.get('email')?.value
          : this.formGroup.get('email')?.value;

      const password = this.mfaType === 'registration'
          ? this.formGroup2.get('password')?.value
          : this.formGroup.get('password')?.value;

      const loginCode = code || (this.actionType === 'mfa' ? this.formGroup2.get('code')?.value : undefined);

      this.authService.login({
          username: email.toLowerCase(),
          password,
          code: loginCode
      }).subscribe((res) => {
          if (res.message === 'MESSAGES.USER.LOGIN_SUCCESS') {
              this.localStorageSvc.set('packageName', res?.packages?.packageName);
              this.login(res);
          } else {
              this.loginResponseHandler(res.message);
          }
      });
    }

    private login(res): void {
        localStorage.removeItem('accessDenied');
        this.localStorageSvc.set('token', res.token);
        //this.setRegistrationTokenExpiry('1m') // set 1 min expire for testing
        this.localStorageSvc.set('user', res);
        this.localStorageSvc.set('partnerName', res?.partner);
        localStorage.removeItem('main_auth_token');
        if (res.company && !res.company.isCompleted) {
            this.localStorageSvc.set('company', res.company);
            // if (this.returnUrl) {
            //   this.router.navigateByUrl(this.returnUrl);
            // } else {
            switch (res.role) {
                case Roles.Customer: {
                    if(res.company.isChReg){
                        this.setRegistrationTokenExpiry(res.registrationTokenExpireIn)
                        this.router.navigateByUrl(`/registration/ch-registration?id=${res.company.id}`);
                        this.notify.showInfo('Your registration has been not completed. Please complete it.');
                    } else if(res.company.isShortYearlyReg){
                        this.setRegistrationTokenExpiry(res.registrationTokenExpireIn)
                        this.router.navigateByUrl(`/registration/short-yearly-registration?id=${res.company.id}`);
                        this.notify.showInfo('Your registration has been not completed. Please complete it.');
                    } else {
                        this.router.navigateByUrl(`/registration/long-registration?id=${res.company.id}`);
                        this.notify.showInfo('Your registration has been not completed. Please fill all fields and click Finish');
                    }
                }; break;
                case Roles.IndVatAccount: {
                    this.router.navigateByUrl(`/registration/ind-vat-registration?id=${res.company.id}`);
                    this.notify.showInfo('Your registration has been not completed. Please fill all fields and click Finish');
                }; break;
                case Roles.OfflineShopOwner: {
                    this.router.navigateByUrl(`/registration/long-registration-offline?id=${res.company.id}`);
                    this.notify.showInfo('Your registration has been not completed. Please fill all fields and click Finish');
                }; break;
            }
            return;
            //  }
        } else {
            this.userSvc.user$.next(res);
            this.localStorageSvc.set('user', JSON.stringify(this.userSvc.user));
            if (this.userSvc.user.role === Roles.Admin || this.userSvc.user.role === Roles.ShipmentsAdmin) {
                this.router.navigateByUrl('/admin-profile');
            } else {
                if (this.returnUrl) {
                    console.log(this.returnUrl);
                    this.router.navigateByUrl(decodeURIComponent(this.returnUrl));
                    return;
                }
                if (res.role === Roles.Customer ||
                    this.userSvc.user.role === Roles.DelicateCustomer ||
                    this.userSvc.user.role === Roles.DelicateAdmin ||
                    this.userSvc.user.role === Roles.OfflineShopOwner ||
                    this.userSvc.user.role === Roles.DelegateOfflineShopOwner
                ) {
                    const redirect = this.localStorageSvc.get('redirectTo');
                    if (!!redirect) {
                        const path = redirect.split('?');
                        if (path?.[0] && (path?.[0] === 'monthly-payment' || path?.[0] === 'commission-payment')) {
                            this.router.navigateByUrl(redirect);
                        } else {
                            switch (redirect) {
                                case 'products':
                                    this.router.navigateByUrl(`products`);
                                    break;
                                case 'pay':
                                    this.router.navigateByUrl(`payments/pay`);
                                    break;
                                case 'online-shop':
                                    break;
                                case 'payment-methods':
                                case 'empact-shop':
                                default:
                                    this.router.navigateByUrl(`customers-management/details/${res.company.id}`);
                                    break;
                            }
                        }
                    } else {
                        this.router.navigateByUrl('dashboard');
                    }
                }
                if (this.userSvc.user.role === Roles.OfflineShopOwner || this.userSvc.user.role === Roles.DelegateOfflineShopOwner) {
                    // this.router.navigateByUrl(`customers-management/details/${res.company.id}`);
                    this.router.navigateByUrl('sales-order-management/marketplace-sales-management');
                }
                if (res.role === Roles.IndVatAccount) {
                    // this.router.navigateByUrl('dashboard');
                    this.router.navigateByUrl('sales-order-management/indvat-sales-order-management');
                }
                if (res.role === Roles.Customer && res?.packages?.packageName == 'B2B'){
                    this.router.navigateByUrl('sales-order-management/b2b-sales-order-management');
                }
                /*if (res.role === Roles.Customer && res?.packages?.packageName == 'B2C'){
                    this.router.navigateByUrl('sales-order-management');
                }*/
                if (res.role === Roles.PartnerAccount) {
                    this.router.navigateByUrl(`/partners-management/details/${this.userSvc.userId}/partner-details`);
                }
                if (res.role === Roles.DelegatePartnerAccount) {
                    this.router.navigateByUrl(`/partners-management/details/${this.userSvc.user?.parentId?this.userSvc.user?.parentId : this.userSvc.userId}/partner-details`);
                }

            }
            //this.router.navigateByUrl('dashboard');
        }
    }

  public forgot() {
    if (this.formGroup2.invalid) return;
    const { email, password, code, repeatPassword } = this.formGroup2.value;
    if (password.toString() === repeatPassword.toString()) {
      this.authService.forgotPassword({ username: email, code: code, password: password }).subscribe(res => {
        this.showAdditionalsFields = true;
        if (!this.isFirstTime) {
          this.actionType = 'login';
        } else {
          this.isFirstTime = false;
        }
      }, (err) => {
        if (!this.showAdditionalsFields) this.notify.showError("User not found in the system")
        else this.notify.showError("Invalid Forgot Code")
      });
    } else {
      this.notify.showError('Passwords does not match');
    }
  }

  checkPasswords(group: FormGroup = this.formGroup2) {
    const pass = group.controls.password.value;
    const confirmPass = group.controls.repeatPassword.value;

    return pass.toString() === confirmPass.toString() ? true : false;
  }

  openChoosePopup(): void {
    if (environment.production) {
        window.location.href = "https://empact.online/pricing/";  // Because now we showing bussiness-type on wordpress website
    } else {
        this.router.navigate(['../../bussiness-type']);
        // const dialogRef = this.dialog.open(BusinessChoosePopupDialog);

        // dialogRef.afterClosed().subscribe(value => {
        //   switch (value) {
        //     case ShopType.Online: this.router.navigate(['../../registration/long-registration']); break;
        //     case ShopType.Offline: this.router.navigate(['../../registration/long-registration-offline']); break;
        //     case ShopType.IndVATNumber: this.router.navigate(['../../registration/ind-vat-registration']); break;
        //   }
        // });
    }
  }

  public toggleShowPassword(): void {
    this.showPassword = !this.showPassword;
  }

    public codeSubmit(code: string): void {
        this.onSubmit(code);
    }

    public sendCode(): void {
        const {email, password} = this.formGroup.value;
        this.authService.sendCode(email, password)
            .subscribe((res) => {
                this.mfaSendCodeResponseHandler(res.message);
            }, (err) => {
                this.notify.showError('User not found in the system');
            });
    }

    private loginResponseHandler(message: string): boolean {
        switch (message) {
            case 'MESSAGES.USER.INVALID_LOGIN':
                this.notify.showError('Incorrect Login or Password');
                break;
            case 'MESSAGES.USER.USER_DISABLED':
                this.notify.showError('This user is disabled');
                break;
            case 'MFA.ERRORS.SUBMIT.LIMIT': {
                this.notify.showError('Your code has been locked. Try get new code.');
                break;
            }
            case 'MFA.ERRORS.CODE_EXPIRED': {
                this.notify.showError('Code has expired. Please request a new code to continue.');
                break;
            }
            case 'MFA.ERRORS.NOT_FOUND':
                this.notify.showError('Code not found. Please try again.');
                break;
            case 'MFA.CODE_NOT_MATCH': {
                this.notify.showError('Wrong code. Please try again.');
                break;
            }
            default:
                this.notify.showError(message);
        }
        return false;
    }

    private mfaSendCodeResponseHandler(message: string): void {
        switch (message) {
            case 'USER.ERRORS.EMAIL_OR_PASSWORD':
            case 'USER.ERRORS.NOT_FOUND': {
                this.notify.showError('User not found');
                break;
            }
            case 'MFA.CODE_LIMIT': {
                this.notify.showError('Your account has been temporarily locked. Try again after 5 minute.');
                this.isUserLock = true;
                setTimeout(() => {
                    this.isUserLock = false;
                }, this.LOCK_TIME);
                break;
            }
            // case 'USER.NOT_COMPLETED_REGISTRATION': {
            //     this.onSubmit();
            //     break;
            // }
            case 'USERS.SEND_CODE_SUCCESS': {
                this.notify.showInfo('We will send the code to email address. Please note that after 5 failed attempts your account will be temporarily locked');
                this.actionType = 'mfa';
                break;
            }
            case 'USER.DISABLED': {
                this.notify.showError('This user is disabled');
                break;
            }
            default:
                this.notify.showError(message);
        }
    }

  /**
   * Call this after login/register
   * @param expiresInStr backend string like '30m', '1h'
   */
  setRegistrationTokenExpiry(expiresInStr: string): void {
    const expiresInMs = this.parseExpiry(expiresInStr);
    const tokenExpiry = Date.now() + expiresInMs;
    this.localStorageSvc.set('registrationTokenExpireIn', tokenExpiry.toString());
  }

  /**
   * Parses expiry strings like "30m", "1h", "2d"
   */
  private parseExpiry(value: string): number {
    const num = parseInt(value, 10);
    if (value?.endsWith('m')) return num * 60 * 1000;
    if (value?.endsWith('h')) return num * 60 * 60 * 1000;
    if (value?.endsWith('d')) return num * 24 * 60 * 60 * 1000;
    return num * 1000; // assume seconds if no unit
  }
}
